<template>
	<LineChart
		:chart-data="chartData"
		:chart-options="chartOptions"
		:loading="isLoading"
		:error="loadError"
		@retry="loadProcessCounts"
	/>
</template>

<script>
import LineChart from '../../../../../../shared/components/chart/line-chart.vue'
import { getProcessCounts } from '../../../../../../shared/utils/api/processing.js'

export default {
	components: { LineChart },
	props: {
		items: Array,
		pointRadius: {
			type: Boolean,
			default: false
		},
		chartApiParams: Object,
		dateFrom: String,
		dateTo: String
	},
	data () {
		return {
			processesChartData: [],
			// Starts true because created() fetches immediately. Without this
			// the chart would report "No data found" for the whole request.
			isLoading: true,
			loadError: null,
			chartOptions: {
				responsive: true,
				maintainAspectRatio: false
			}
		}
	},
	computed: {
		filteredProcesses () {
			const processIds = this.items.map(({ processId }) => processId)
			return this.processesChartData.filter(({ processId }) => processIds.includes(processId))
		},
		modifiedProcesses () {
			const colorsMap = new Map(this.items.map(i => [i.processId, i.processColor]))

			return this.filteredProcesses.map(process => ({
				...process,
				processColor: colorsMap.get(process.processId)
			}))
		},
		chartData () {
			const pointRadius = this.pointRadius ? undefined : 0

			const labels = {}
			const datasets = []

			this.modifiedProcesses.forEach(process => {
				const { processCounts, processName, processColor } = process

				const data = []

				processCounts.forEach(obj => {
					const [label, value] = Object.entries(obj).flat()

					data.push(value)
					labels[label] = null
				})

				datasets.push({
					borderColor: processColor,
					label: processName,
					data,
					pointRadius
				})
			})
			return {
				labels: Object.keys(labels),
				datasets
			}
		}
	},
	watch: {
		chartApiParams () {
			this.loadProcessCounts()
		}
	},
	async created () {
		this.loadProcessCounts()
	},
	methods: {
		async loadProcessCounts () {
			this.isLoading = true
			this.loadError = null
			try {
				const { data: { processes } } = await getProcessCounts(this.chartApiParams.processes, this.chartApiParams.dateFrom, this.chartApiParams.dateTo)
				this.processesChartData = processes
			} catch (error) {
				// Previously this rejected unhandled and the chart just sat
				// blank. The chart can now say the load failed and offer a
				// retry, which is the whole point of AB#26801.
				this.loadError = error
			} finally {
				this.isLoading = false
			}
		}
	}
}
</script>
